"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const measure_model_1 = require("../../shared/model/measure.model");
/**
 * Created by aghavni.grigoryan on 6/20/2017.
 */
class ListReportModel {
    constructor() {
        /**
         * Report row categories
         * @type {Array}
         * @private
         */
        this._rowCategories = [];
        /**
         * Report column categories
         * @private
         * @type {Array}
         */
        this._columnCategories = [];
        /**
         * Report column measures
         * @private
         * @type {Array}
         */
        this._columnMeasures = [];
    }
    get rowCategories() {
        return this._rowCategories;
    }
    set rowCategories(rowCategoies) {
        this._rowCategories = rowCategoies;
    }
    get columnCategories() {
        return this._columnCategories;
    }
    set columnCategories(columnCategories) {
        this._columnCategories = columnCategories;
    }
    get columnMeasures() {
        return this._columnMeasures;
    }
    set columnMeasures(columnMeasures) {
        this._columnMeasures = columnMeasures;
    }
    validateReport() {
        if (this._rowCategories.length) {
            return (!!this._columnMeasures.length || !!this._columnCategories.length);
        }
        return false;
    }
    toJson() {
        let toJsonData = "";
        toJsonData += "{";
        toJsonData += "\"rowCategories\":";
        toJsonData += "[";
        let rowCategoriesLength = this.rowCategories.length;
        for (let i = 0; i < rowCategoriesLength; ++i) {
            if (i !== 0) {
                toJsonData += ",";
            }
            toJsonData += this._rowCategories[i];
        }
        toJsonData += "]";
        toJsonData += ",";
        toJsonData += "\"columnCategories\":";
        toJsonData += "[";
        let columnCategoriesLength = this.columnCategories.length;
        for (let i = 0; i < columnCategoriesLength; ++i) {
            if (i !== 0) {
                toJsonData += ",";
            }
            toJsonData += this._columnCategories[i];
        }
        toJsonData += "]";
        toJsonData += ",";
        toJsonData += "\"columnMeasures\":";
        toJsonData += JSON.stringify(this._columnMeasures);
        toJsonData += "}";
        return toJsonData;
    }
    fromJson(jsonObject) {
        this.rowCategories = jsonObject.rowCategories == undefined ? [] : jsonObject.rowCategories;
        this.columnCategories = jsonObject.columnCategories == undefined ? [] : jsonObject.columnCategories;
        this.columnMeasures = jsonObject.columnMeasures == undefined ? [] :
            jsonObject.columnMeasures
                .map(measure => measure_model_1.MeasureModel.fromJSON(measure));
    }
}
exports.ListReportModel = ListReportModel;
//# sourceMappingURL=list-report.model.js.map